import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "suspend-icon" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "menu-center-wrap",
      style: _normalizeStyle($data.positionStyle),
      ref: "dragSuspendIcon",
      onTouchstart: _cache[0] || (_cache[0] = _withModifiers($event => ($options.touchstartHandle('dragSuspendIcon',$event, true)), ["stop"])),
      onTouchmove: _cache[1] || (_cache[1] = _withModifiers($event => ($options.touchmoveHandle('dragSuspendIcon',$event, true)), ["stop","prevent"])),
      onTouchend: _cache[2] || (_cache[2] = _withModifiers($event => ($options.touchendHandle('dragSuspendIcon',$event, true)), ["stop","prevent"])),
      onClick: _cache[3] || (_cache[3] = (...args) => ($options.clickIcon && $options.clickIcon(...args)))
    }, [
      _createVNode(_component_van_image, { src: $props.iconUrl }, null, 8, ["src"])
    ], 36)), [
      [_directive_audio]
    ])
  ]))
}